<agpr-dialog-container
    [id]="'editInsightDialog'"
    [heading]="'Mention.insights.editInsightDialog.edit' | localize"
    (close)="cancel()"
>
    <div
        class="agpr-editInsightDialog"
    >
        <agpr-scroll-panel>
            <agpr-text-input
                [placeholder]="'Mention.workbench.insights.name.placeholder'"
                [id]="'mentionWorkbenchDialog_prompt_name'"
                [label]="'Mention.workbench.insights.name'"
                [(ngModel)]="name"
            ></agpr-text-input>
            <div
                class="agpr-editInsightDialog-label"
            >
                {{'Mention.workbench.insight' | localize}}
            </div>
            <div class="agpr-editInsightDialog-content">
                <agpr-rich-text-editor-ck
                    [richTextEditorConfig]="ckEditorConfig"
                    [(ngModel)]="content"
                ></agpr-rich-text-editor-ck>
            </div>
        </agpr-scroll-panel>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            id="editInsightDialog_cancel'"
            label="Mention.insights.editInsightDialog.cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="editInsightDialog_saveInsight'"
            label="Mention.insights.editInsightDialog.saveInsight"
            [disabled]="!name || !content"
            [style]="buttonTypes.primary"
            (click)="ok()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
